// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5fd8d96e","76":"6c925d39","253":"942185d5","340":"8be5699b","496":"e0a6a109","542":"83dfcf45","678":"f82b1d8e"}[chunkId] + ".chunk.js";
};